export default "__VITE_ASSET__Djf7r6bJ__"